import { useCustomizations } from '@client/new/hooks/use-customizations';

// Permission-style hook: collapses loading to false so the edit affordance
// stays hidden until the flag is confirmed on.
export const useIsContentEditEnabled = (influencerId?: string): boolean => {
  const { customizations } = useCustomizations(influencerId);

  return customizations?.isCommunityContentEditEnabled === true;
};
